export default __webpack_public_path__ + "static/media/landscape.72be3e8a.svg";